export const GAD7Questions: { [index: string]: string } = {
  feeling_nervous_anxious_edge: 'Feeling nervous, anxious, or on edge',
  unable_to_stop_worrying: 'Not being able to stop or control worrying',
  worrying_about_too_much: 'Worrying too much about different things',
  cannot_relax: 'Trouble relaxing',
  restless_and_cannot_be_still: "Being so restless that it's hard to sit still",
  easily_irritable: 'Becoming easily annoyed or irritable',
  feeling_afraid: 'Feeling afraid as if something awful might happen',
  sum: 'Score'
};
export const GAD7Choices = [
  'Not at all',
  'Several days',
  'More than half the days',
  'Nearly every day'
];

export const PHQ9Questions: { [index: string]: string } = {
  little_interest: 'Little interest or pleasure in doing things',
  feeling_down: 'Feeling down, depressed or hopeless',
  trouble_sleeping: 'Trouble falling asleep, staying asleep, or sleeping too much',
  feeling_tired: 'Feeling tired or having little energy',
  poor_appetite: 'Poor appetite or overeating',
  feeling_bad_about_yourself:
    'Feeling bad about yourself - or that you’re a failure or have let yourself or your family down',
  trouble_concentrating:
    'Trouble concentrating on things, such as reading the newspaper or watching television',
  moving_or_speaking_slower_or_faster_than_normal:
    'Moving or speaking so slowly that other people could have noticed. Or, the opposite - being so fidgety or restless that you have been moving around a lot more than usual',
  thoughts_of_self_harm:
    'Thoughts that you would be better off dead or of hurting yourself in some way',
  sum: 'Score'
};
export const PHQ9Choices = [
  'Not at all',
  'Several days',
  'More than half the days',
  'Nearly every day'
];

// Counselors read the member's own words first, so freeform answers sort above
// the rest.
export const FREEFORM_ANSWER_RANK: { [index: string]: number } = {
  input_long: 0,
  input_short: 1,
  daily_journal: 1,
  default: 2
};
